module.exports = __webpack_public_path__ + "img/legal-and-general-logo-white.2bf4eb8f.png";